import type { RouteListItem } from '@/types';

import { type CommissionPlansFormSchema } from './schemas';
import { defaultCommissionEarningModel } from './schemas/commission-earning-model-schema';

import { currencyInput } from '../../../../_schemas/generic/currency';
import { percentageInput } from '../../../../_schemas/generic/percentage';
import { settingsBcLink } from '../../model';

export const defaultValues = {
  id: -1,
  name: '',
  commission_tiers: [],
  base_quota_amount: currencyInput.defaultValue(),

  default_one_time_rate: percentageInput.defaultValue(),
  default_recurring_rate: percentageInput.defaultValue(),

  bonus_amount: currencyInput.defaultValue(),
  bonus_threshold: currencyInput.defaultValue(),
  commission_earning_model: defaultCommissionEarningModel,
} as CommissionPlansFormSchema;

export const breadcrumbsLinks: RouteListItem[] = [
  settingsBcLink,
  { path: '/settings/commission-plans', name: 'Commission Plans' },
];
